<template>
  <Breadcrumb>
    <BreadcrumbItem v-for="(item, index) in mete.parent" :key="index" :to="item.name">{{ item.title }}</BreadcrumbItem>
    <BreadcrumbItem>{{ mete.title }}</BreadcrumbItem>
  </Breadcrumb>
</template>

<script>
export default {
  name: 'headerNav',
  data () {
    return {
      mete: ''
    }
  },
  created () {
    this.mete = this.$route.meta
    console.log(this.mete)
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/breadcrumb.vue